import {DatePipe, NgTemplateOutlet} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow,
    MatRowDef,
    MatTable
} from '@angular/material/table';
import {MatTooltip} from '@angular/material/tooltip';
import {TranslatePipe} from '@ngx-translate/core';
import {DivisionStructureModel, StructureDepartmentModel} from '../../../models/department.model';
import {MemberModel} from '../../../models/user.model';
import {DepartmentsService} from '../../../services/api/departments.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {StatisticService} from '../../../services/statistic.service';
import {ComponentsModule} from '../../components.module';

type OfficeStatistic = {
    all_members: number,
    clients: number,
}

@Component({
    selector: 'app-office-index-tab',
    standalone: true,
    imports: [
        NgTemplateOutlet,
        ComponentsModule,
        DatePipe,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatRow,
        MatRowDef,
        MatTable,
        MatHeaderCellDef,
        MatNoDataRow,
        MatTooltip,
        TranslatePipe,
    ],
    templateUrl: './office-index-tab.component.html',
    styleUrl: './office-index-tab.component.scss'
})
export class OfficeIndexTabComponent implements OnInit {
    @Input() currentMember: MemberModel;

    mainTabs: 'clients' | 'members' | 'structure';

    clientsTab: 'legal' | 'individual' = 'legal';

    membersTab: 'staff' | 'outStaff' = 'staff';

    structureTab: 'horizontally' | 'vertically' = 'horizontally';

    allMembers: {
        staff: MemberModel[],
        outStaff: MemberModel[],
        total: number
    };

    copyAllMembers: {
        staff: MemberModel[],
        outStaff: MemberModel[],
        total: number
    };

    projectStructure: StructureDepartmentModel[];
    departmentsMembers: { [key: string]: MemberModel };

    path: Array<number | null> = [];
    pathMargin: Array<number | null> = [];
    columns: any[][];

    statisticData: OfficeStatistic;

    constructor(
        private membersService: MemberService,
        private departmentApi: DepartmentsService,
        private statistic: StatisticService,
        public helper: HelpersService,
    ) {
        this.getStatistic();
    }

    ngOnInit() {
        this.changeMainTab('structure');
    }

    getStatistic(): void {
        this.statistic.getIndexPageStatistics('office').subscribe({
            next: res => {
                this.statisticData = res.office as OfficeStatistic;
            }
        });
    }

    changeMainTab(newTab: 'clients' | 'members' | 'structure'): void {
        if (this.mainTabs === newTab) {
            return;
        }
        this.mainTabs = newTab;

        switch (newTab) {
            case 'clients':
                if (this.clientsTab === 'legal') {
                    //TODO гет юрлиц
                } else {
                    //TODO гет физлиц
                }
                break;
            case 'members':
                this.getAllMembers();
                break;

            case 'structure':
                this.getProjectStructure();
        }
    }

    getAllMembers(): void {
        this.membersService.getAllMembers().then((members: MemberModel[]) => {
            this.allMembers = {
                staff: members.filter(member => !['blocked', 'outer'].includes(member.project_setting.observation_type)),
                outStaff: members.filter(member => ['blocked', 'outer'].includes(member.project_setting.observation_type)),
                total: members.length
            };

            this.copyAllMembers = structuredClone(this.allMembers);
        });
    }

    searchInMembers(text: string) {
        if (text) {
            this.allMembers = structuredClone(this.copyAllMembers);

            this.allMembers.staff = this.filterMembersBySearch(this.allMembers.staff, text);
            this.allMembers.outStaff = this.filterMembersBySearch(this.allMembers.outStaff, text);
        } else {
            this.allMembers = structuredClone(this.copyAllMembers);
        }
    }

    public filterMembersBySearch(members: MemberModel[], searchText: string): MemberModel[] {
        let filteredMembers: MemberModel[];

        const association = (data: string, searchFromStart = false) => {
            if (searchFromStart) {
                return data.toLowerCase().indexOf(searchText.toLowerCase()) === 0;
            }
            return data.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        };

        if (searchText) {
            filteredMembers = members.filter(member => {
                const searchFieldsValue = member.project_setting.position +
                    member.project_setting.position +
                    member.email +
                    member.firstname +
                    member.lastname +
                    member.middlename;

                if (association(searchFieldsValue)) {
                    return member;
                } else {
                    return null;
                }
            });
            return filteredMembers;
        } else {
            return members;
        }
    }

    getProjectStructure(): void {
        this.departmentApi.getStructureDepartments().subscribe({
            next: res => {
                this.projectStructure = res.departments;
                this.departmentsMembers = res.members;
                this.buildColumns();
            }
        });
    }

    buildColumns(): void {
        this.columns = [];

        let list: any[] = this.projectStructure;
        this.columns.push(list);

        for (let lvl of this.path) {
            const selected = list.find(item => (item.department_id ?? item.id) === lvl);
            if (!selected) {
                break;
            }

            const children = this.getChildren(selected);
            if (!children?.length) {
                break;
            }

            list = children;
            this.columns.push(list);
        }

        console.log(this.columns);
    }

    onSelect(node: any, level: number): void {
        const id = node.department_id ?? node.id;

        if (this.path[level] === id) {
            this.path = this.path.slice(0, level);
        } else {
            this.path[level] = id;
            this.path = this.path.slice(0, level + 1);
        }

        this.buildColumns();

        console.log(this.path);
    }

    getChildren(node: any): any[] | null {
        if (node.divisions) {
            return node.divisions;
        }
        if (node.subdivision) {
            return node.subdivision;
        }
        return null;
    }

    getMargin(): number {
        return 0;
    }
}
